import restAPI from "../http-common";
import session from "./session";
import AdApi from "./Api";
import { edibleVsInedibleRequest } from "./CancellableRequest";

class WasteTypeApi {
	getWasteType() {
		edibleVsInedibleRequest.cancel();

		return restAPI({
			method: "get",
			url: "/avoidable-vs-unavoidable",
			params: AdApi.getQueryParams(),
			headers: session.getIdToken() ? { Authorization: session.getIdToken() } : {},
			cancelToken: edibleVsInedibleRequest.generateCancelToken(),
		});
	}
}

export const WasteTypeService = new WasteTypeApi();
